import axios from "axios";
import { API_GET_ANALYTICS_DATA, API_GET_ORDERS_DATA, API_GET_ORDER_ANALYTICS, API_INSERT_ORDER_DATA, API_TOGGLE_ORDER_DATA, API_UPDATE_ORDER_STATUS } from ".";

export const getOrdersList = async (func, config, id) => {
    let URL = "";
    if (id) {
        URL = `${API_GET_ORDERS_DATA}?order_id=${id}`;
    } else {
        URL = API_GET_ORDERS_DATA;
    }
    return axios.get(URL, config).then(res => func(res.data.data));
}

export const getAnalytics = async ( func, config, query) => {
    if (query) {
        const { fromDate, toDate } = query;
        return axios.get(`${API_GET_ANALYTICS_DATA}?fromDate=${fromDate}&toDate=${toDate}`, config).then(res => func(res.data.data));
    }
    return axios.get(API_GET_ANALYTICS_DATA, config).then(res => func(res.data.data));
}

export const insertOrderData = async (data, config) => {
    return axios.post(API_INSERT_ORDER_DATA, data, config).then((res) => res.data);
};

export const getOrderAnalytics = async (func, config) => {
    return axios.get(API_GET_ORDER_ANALYTICS, config).then((res) => {
        console.log(res.data);
        func(res.data);
    });
};

export const updateOrderStatus = async (data, config, func) => {
    return axios.patch(API_UPDATE_ORDER_STATUS, data, config).then((res) => func());
};

export const toggleOrderData = async (data, config, cb) => {
    return axios.put(API_TOGGLE_ORDER_DATA, data, config).then((res) => {
        if (res.data.status === "success") {
            cb();
        };
    });
};